import {
  Box,
  Heading,
  Container,
  Text,
  Button,
  Stack,
  SimpleGrid,
  InputGroup,
  InputLeftElement,
  Input,
  useColorModeValue,
} from '@chakra-ui/react';

import React, { useEffect, useState } from 'react';

import { bankService } from '../services/bankService';

export default function Home() {
  const [usd, setUsd] = useState({});
  const [dateUpdate, setDateUpdate] = useState(null);
  const color = useColorModeValue('white', 'white.400');
  const [value, setValue] = useState('');
  const [validData, setValidData] = useState(false);
  const [salary, setSalary] = useState(0);
  const [isShowSalary, setIsShowSalary] = useState(false);

  const handleChange = event => setValue(event.target.value);

  useEffect(() => {
    bankService
      .getData()
      .then(res => {
        if (res.status === 200) {
          const data = res.data?.ExrateList;
          setDateUpdate(data?.DateTime?._text);
          const getUsd = data.Exrate.find(
            x => x._attributes?.CurrencyCode === 'USD'
          )._attributes;
          setUsd(getUsd);
        }
      })
      .catch(err => {
        alert('Có lỗi xảy ra!');
      });
  }, []);

  const sumSalary = () => {
    if (value) {
      setValidData(false);
      const usdValue = Number(usd?.Sell.replace(/[^0-9.-]+/g, ''));
      const salaryTotal = usdValue * Number(value);
      const salaryFinal = salaryTotal.toLocaleString('it-IT', {
        style: 'currency',
        currency: 'VND',
      });

      setSalary(salaryFinal);
      setIsShowSalary(true)

    } else {
      setValidData(true);
      setIsShowSalary(false)
      alert('Vui lòng nhập lương của bạn!');
    }
  };
  return (
    <>
      <Container maxW={'3xl'}>
        <Stack spacing={0} align={'center'}>
          <Heading>Tỷ giá ngoại tệ của Vietcombank</Heading>
          <Text fontSize={'sm'}>
            Tỷ giá được cập nhật lúc {dateUpdate} và chỉ mang tính chất tham
            khảo
          </Text>
        </Stack>
        <Stack
          as={Box}
          textAlign={'center'}
          spacing={{ base: 8, md: 14 }}
          py={{ base: 10, md: 10 }}
        >
          <Heading
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '4xl', md: '6xl' }}
            lineHeight={'110%'}
          >
            1 US DOLLAR <br />
            <Text as={'span'} color={'green.400'}>
              {usd?.Sell}đ
            </Text>
          </Heading>

          <SimpleGrid columns={[2, null, 3]} spacing="40px">
            <Box bg="green.500" rounded={'md'}>
              <Text as={'b'} color={color}>
                Tiền mặt <br />
                {usd?.Buy}đ
              </Text>
            </Box>
            <Box bg="green.500" rounded={'md'}>
              <Text as={'b'} color={color}>
                Chuyển khoản
                <br /> {usd?.Transfer}đ
              </Text>
            </Box>
            <Box bg="green.500" rounded={'md'}>
              <Text as={'b'} color={color}>
                Bán
                <br /> {usd?.Sell}đ
              </Text>
            </Box>
          </SimpleGrid>

          <Stack spacing={4}>
            <Text>Công cụ quy đổi tiền lương</Text>
            <InputGroup>
              <InputLeftElement
                pointerEvents="none"
                color="gray.300"
                fontSize="1.2em"
                children="$"
              />

              <Input
                placeholder="Nhập tiền lương"
                size="lg"
                value={value}
                onChange={handleChange}
                isInvalid={validData}
                errorBorderColor="crimson"
              />
            </InputGroup>
            <Stack
              direction={'column'}
              spacing={3}
              align={'center'}
              alignSelf={'center'}
              position={'relative'}
            >
              <Button
                colorScheme={'green'}
                bg={'green.400'}
                rounded={'full'}
                px={6}
                _hover={{
                  bg: 'green.500',
                }}
                onClick={() => {
                  sumSalary();
                }}
              >
                Tính lương
              </Button>
            </Stack>

            {isShowSalary ? (
              <>
                <Heading as="h3" size="lg">
                  Lương của bạn là : {salary}
                </Heading>
              </>
            ) : null}
          </Stack>
        </Stack>
      </Container>
    </>
  );
}